import { setupCanvas } from "./setupCanvas";

export function CreateCanvas() {
  var newCanvas = document.createElement("canvas");
  newCanvas = setupCanvas(newCanvas);

  return newCanvas;
}
